import { getIdToken } from "@/features/auth/api/identity-platform-auth";
import { createHttpClient, normalizeApiBaseUrl } from "@/shared/api/http-client";
import { env } from "@/shared/config/env";

const platformApiBaseUrl = normalizeApiBaseUrl(env.VITE_PLATFORM_API_URL, {
  allowHttp: env.VITE_DEPLOY_ENV === "local",
});

/**
 * Application-wide client for the Platform API. Before authentication the
 * token provider returns null, which also allows public Platform endpoints
 * such as tenant discovery to use the same client.
 */
export const platformHttpClient = createHttpClient({
  baseUrl: platformApiBaseUrl,
  getToken: getIdToken,
});
